import React, { useState, useEffect, useContext } from 'react';
import {Stack} from '@shopify/polaris';
import {FormProvider, useFetch} from '@thinkwell/react.common';
import {EditModal, TextField, Checkbox} from '@thinkwell/react.polaris';
import { CourseTreeContext } from '../contexts/CourseTree'

export default function EditContainer(props) {
  const [courseTree, updateCourseTree] = useContext(CourseTreeContext)
  const item = props.item || {}

  const onEditSave = (node) => {
    courseTree.updateNode(node)
    updateCourseTree(courseTree)
    props.onSave && props.onSave(node)
  }

  const onActive = (active) => {
    props.onActive && props.onActive(active)
  }

  let url;
  if (item.id) {
    url = `/nodes/${item.id}.json`
  } else {
    url = `/nodes.json?type=container`
  }

  return (
    <FormProvider data={{data: item}} rootName="node"><EditModal
      onSave={onEditSave}
      url={url}
      method={item.id ? 'put' : 'post'}
      linkText={props.linkText ? <span className="edit-container">{props.linkText}</span> : null}
      title={props.title}>
      <TextField required
        label="Name"
        name="name"
      />
      <TextField
        type="number"
        label="Number"
        name="number"
      />
      <TextField
        label="Book Number"
        name="book_number"
      />
      <Checkbox
        label="Numbering enabled"
        name="numbering_enabled"
      />
      <TextField
        label="Override Label"
        name="override_label"
      />
    </EditModal></FormProvider>
  );
}
